import { modalMapper } from ".";
import { Suspense } from "react";
import { Box, IconButton, Modal, useMediaQuery, useTheme } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { modalActions } from "redux/slices/modal";
import { MODAL } from "redux/slices/modal";
import CircleLoader from "components/atoms/CircleLoader";
import ErrorBoundary from "components/atoms/ErrorBoundary";
import { useAppDispatch, useAppSelector } from "redux/hooks";

function AppModal() {
	const dispatch = useAppDispatch();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const type = useAppSelector((state) => state.modal.type);
	const open = useAppSelector((state) => state.modal.open);
	const width = useAppSelector((state) => state.modal.width);
	const loading = useAppSelector((state) => state.modal.loading);
	const closeBackdropClick = useAppSelector(
		(state) => state.modal.closeBackdropClick
	  );
	const isMapModal = type === MODAL.EDIT_ADDRESS1;

	return (
		<Modal
			open={open}
			onClose={(_, reason) => {
				if (reason !== "backdropClick"||closeBackdropClick)
					dispatch(modalActions.closeModal());
			}}
			sx={{
				padding: isMobile ? 0 : "16px",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			}}
		>
			<Box
				className="app-modal-body"
				sx={{
					p: isMapModal ? 2 : isMobile ? 2 : 4,
					width: "100%",
					height: isMobile ? "100%" : "auto",
					boxShadow: 24,
					border: "none",
					borderRadius: isMobile ? 0 : 1,
					maxWidth: isMobile ? "100%" : width,
					maxHeight: isMobile ? "100%" : "90vh",
					overflowY: isMapModal ? "hidden" : "auto",
					bgcolor: "background.paper",
				}}
			>
				<ErrorBoundary>
					<Box sx={{ minHeight: isMapModal ? undefined : "123px", position: "relative" }}>
						{isMapModal ? null :
						<IconButton
							onClick={() => dispatch(modalActions.closeModal())}
							size="small"
							sx={{
								position: "absolute",
								top: -8,
								right: -8,
								zIndex: 1,
								bgcolor: "background.paper",
								boxShadow: 1,
								"&:hover": { bgcolor: "action.hover" },
							}}
						>
							<CloseIcon fontSize="small" />
						</IconButton>}

						{loading && <CircleLoader />}

						<Suspense fallback={<CircleLoader />}>
							{type && modalMapper[type]}
						</Suspense>
					</Box>
				</ErrorBoundary>
			</Box>
		</Modal>
	);
}
export default AppModal;
